<mwe-basic-card cardTitle="idcard.title" iconClass="far fa-id-card-alt" optionalLastChildClass="mb-n3">
  <mwe-form
    [formModel]="formModel"
    (formIsValid)="handleFormValidation(true, $event)"
    (formIsInvalid)="handleFormValidation(false, $event)"
  />
</mwe-basic-card>
